var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", {
          staticClass: "q-mb-sm",
          attrs: { name: "fas fa-clipboard-check" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("courses_catalog")) + "\n        ")
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-field",
            { attrs: { count: 256 } },
            [
              _c("q-input", {
                attrs: {
                  "float-label": _vm.$t("course_name"),
                  error: _vm.$v.title.$error,
                  disable: _vm.disableEditCatalog
                },
                on: { input: _vm.$v.title.$touch },
                model: {
                  value: _vm.title,
                  callback: function($$v) {
                    _vm.title = $$v
                  },
                  expression: "title"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-field",
            { attrs: { count: 1024 } },
            [
              _c("q-input", {
                attrs: {
                  type: "textarea",
                  error: _vm.$v.description.$error,
                  "float-label": _vm.$t("description"),
                  disable: _vm.disableEditCatalog
                },
                on: { input: _vm.$v.description.$touch },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c(
            "q-field",
            { attrs: { helper: _vm.$t("training_code_helper_message") } },
            [
              _c("q-input", {
                attrs: {
                  type: "text",
                  error: _vm.$v.code.$error,
                  "float-label": _vm.$t("training_code"),
                  disable: _vm.disableEditCatalog
                },
                on: { input: _vm.$v.code.$touch },
                model: {
                  value: _vm.code,
                  callback: function($$v) {
                    _vm.code = $$v
                  },
                  expression: "code"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _vm.selectedClientParams.use_presential_events_certificate_expiration
            ? _c("inputExpireCertificate", {
                attrs: {
                  disable: _vm.disableEditCatalog,
                  qty_days: _vm.qty_days
                },
                on: { fnInDays: _vm.fnInDays }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 q-mt-md" },
        [
          _c("p", { staticClass: "caption q-mb-xs" }, [
            _vm._v(_vm._s(_vm.$t("categories_modules")))
          ]),
          _c("q-checkbox", {
            staticClass: "q-mb-xs",
            attrs: {
              val: true,
              label: _vm.$t("select_all_categories_modules"),
              disable: _vm.disableEditCatalog
            },
            on: {
              input: function($event) {
                return _vm.checkAllCategories()
              }
            },
            model: {
              value: _vm.all_product_categories,
              callback: function($$v) {
                _vm.all_product_categories = $$v
              },
              expression: "all_product_categories"
            }
          }),
          _c("q-select", {
            ref: "product_categories",
            attrs: {
              options: _vm.product_categories_list.map(function(e) {
                return { value: e.value, label: e.title }
              }),
              multiple: "",
              chips: "",
              filter: "",
              error: _vm.$v.product_categories.$error,
              disable: _vm.disableEditCatalog
            },
            on: { input: _vm.changeProducts },
            model: {
              value: _vm.product_categories,
              callback: function($$v) {
                _vm.product_categories = $$v
              },
              expression: "product_categories"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 q-mt-md" },
        [
          _c("p", { staticClass: "caption q-mb-xs" }, [
            _vm._v(_vm._s(_vm.$t("products_themes")))
          ]),
          _c("q-checkbox", {
            staticClass: "q-mb-xs",
            attrs: {
              val: true,
              label: _vm.$t("select_all_product_themes"),
              disable:
                _vm.product_categories.length < 1 || _vm.disableEditCatalog
            },
            on: {
              input: function($event) {
                return _vm.checkAllProducts()
              }
            },
            model: {
              value: _vm.all_products,
              callback: function($$v) {
                _vm.all_products = $$v
              },
              expression: "all_products"
            }
          }),
          _c("q-select", {
            ref: "products",
            attrs: {
              options: _vm.filteredProducts,
              multiple: "",
              chips: "",
              filter: "",
              error: _vm.$v.products.$error,
              disable: _vm.disableEditCatalog
            },
            on: { input: _vm.$v.products.$touch },
            model: {
              value: _vm.products,
              callback: function($$v) {
                _vm.products = $$v
              },
              expression: "products"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-select", {
            attrs: {
              options: _vm.optionTags,
              "float-label": _vm.$t("tags"),
              multiple: "",
              chips: "",
              filter: "",
              "autofocus-filter": "",
              disable: _vm.disableEditCatalog
            },
            model: {
              value: _vm.tags,
              callback: function($$v) {
                _vm.tags = $$v
              },
              expression: "tags"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("p", { staticClass: "caption" }, [
            _vm._v(_vm._s(_vm.$t("areas")))
          ]),
          _c("q-checkbox", {
            staticClass: "q-mb-sm",
            attrs: {
              val: true,
              label: _vm.$t("select_all_areas"),
              disable: _vm.disableEditCatalog
            },
            on: {
              input: function($event) {
                return _vm.checkAllAreas()
              }
            },
            model: {
              value: _vm.all_areas,
              callback: function($$v) {
                _vm.all_areas = $$v
              },
              expression: "all_areas"
            }
          }),
          _c("q-select", {
            ref: "area",
            attrs: {
              filter: "",
              "autofocus-filter": "",
              options: _vm.areas,
              error: _vm.$v.area.$error,
              multiple: "",
              chips: "",
              disable: _vm.disableEditCatalog
            },
            on: { input: _vm.$v.area.$touch },
            model: {
              value: _vm.area,
              callback: function($$v) {
                _vm.area = $$v
              },
              expression: "area"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
        _c("p", { staticClass: "caption" }, [
          _vm._v(_vm._s(_vm.$t("profiles")))
        ]),
        _c(
          "div",
          { staticClass: "row gutter-sm" },
          [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-checkbox", {
                  attrs: {
                    val: true,
                    label: _vm.$t("all"),
                    disable: _vm.disableEditCatalog
                  },
                  on: {
                    input: function($event) {
                      return _vm.checkAll()
                    }
                  },
                  model: {
                    value: _vm.all_profiles,
                    callback: function($$v) {
                      _vm.all_profiles = $$v
                    },
                    expression: "all_profiles"
                  }
                })
              ],
              1
            ),
            _vm._l(_vm.profiles, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "col-xs-12 col-sm-4",
                  class: _vm.getErrorClass(_vm.$v.profile.$error)
                },
                [
                  _c("q-checkbox", {
                    ref: "profile",
                    refInFor: true,
                    attrs: {
                      "keep-color": "",
                      val: item.value,
                      label: item.label,
                      color: _vm.getErrorColor(_vm.$v.profile.$error),
                      disable: _vm.disableEditCatalog
                    },
                    on: { input: _vm.$v.profile.$touch },
                    model: {
                      value: _vm.profile,
                      callback: function($$v) {
                        _vm.profile = $$v
                      },
                      expression: "profile"
                    }
                  })
                ],
                1
              )
            })
          ],
          2
        )
      ])
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "fas fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "courses_catalog" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save",
              disable: _vm.disableEditCatalog
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }